import React from 'react'

export default ({ width, height }) => (
  <svg width={width || '18px'} height={height || '37px'} viewBox="0 0 18 37">
    <g id="Page-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M1,18.4765848 L1,12.6667328 L4.56040333,12.6667328 L4.56040333,9.15315992 C4.56040333,4.41415742 5.97632965,1 11.1651822,1 L17.336581,1 L17.336581,6.7960608 L12.9923631,6.7960608 C10.8146484,6.7960608 10.3205476,8.24234753 10.3205476,9.7575901 L10.3205476,12.6666336 L17.0164077,12.6666336 L16.1029164,18.4765848 L10.320746,18.4765848 L10.320746,36 L4.56040333,36 L4.56040333,18.4765848 L1,18.4765848 Z"
        id="Shape"
        stroke="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/facebookIcon.js